/**
 * MantenimientoWrapper.jsx
 * @description Este componente es un wrapper para envolver el componente principal (DashboardPage) con los contextos necesarios para el manejo de plantas y recargas.
 * @author Joaquin
 * @version 1.0.0
 * @date 2025-07-30
 */
import React from "react";
import { PlantaProvider } from "../context/PlantaContext";
import { ReloadProvider } from "../context/ReloadContext";
import DashboardPage from "./dashboard-page";

export default function MantenimientoWrapper() {
  return (
    <PlantaProvider>
      <ReloadProvider>
        <DashboardPage />
      </ReloadProvider>
    </PlantaProvider>
  );
}
